// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LinkEdit: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#e00b5a",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 12 13" width={width} height={height}>
            <path
                fill="currentColor"
                d="m10.735 1.569.286.286a.757.757 0 0 1 0 1.07l-.63.63-1.356-1.356.63-.63a.757.757 0 0 1 1.07 0M4.463 6.77l4.038-4.038L9.857 4.09 5.819 8.127a.8.8 0 0 1-.364.203l-1.55.356.358-1.551a.74.74 0 0 1 .203-.364zm4.669-5.738L3.93 6.238c-.201.2-.34.453-.404.73l-.494 2.139a.38.38 0 0 0 .454.453l2.14-.493c.275-.064.528-.203.729-.404l5.202-5.205a1.51 1.51 0 0 0 0-2.137l-.286-.288a1.51 1.51 0 0 0-2.137 0zm-7.243.977A1.89 1.89 0 0 0 0 3.9v6.8c0 1.045.845 1.89 1.89 1.89h6.8a1.89 1.89 0 0 0 1.89-1.89V7.679a.38.38 0 0 0-.378-.378.38.38 0 0 0-.378.378v3.023c0 .626-.508 1.133-1.134 1.133h-6.8a1.134 1.134 0 0 1-1.134-1.133V3.9c0-.626.507-1.134 1.133-1.134h3.023c.208 0 .378-.17.378-.378a.38.38 0 0 0-.378-.378z"
            />
        </svg>
    );
};

export default React.memo(LinkEdit);
